"use client";

import { Swiper, SwiperSlide } from "swiper/react";

import { TestimonialSwiper as Slider } from "../../../sanity/lib/types/TestimonialSwiper";
import { LinkElement } from "../link/link";

export default function ({ slider }: { slider: Slider }) {
    return (
        <section
            title={slider.title || "Testimonial Slider"}
            className="pt-6 pb-14 testimonial-swiper"
        >
            <h2 className="absolute -top-[100vh]">{slider.title}</h2>

            <div className="container">
                <div className="border-b border-black 3xl:mx-5">
                    <div className="overflow-x-hidden ml-2.5 pb-8">
                        <Swiper
                            slidesPerView={1.2}
                            spaceBetween={12}
                            grabCursor={true}
                            breakpoints={{
                                687: {
                                    slidesPerView: 2.2,
                                },
                            }}
                            role="group"
                            aria-roledescription="carousel"
                            aria-label="Testimonial Slider"
                        >
                            {slider.testimonials?.map((testimonial, index) => (
                                <SwiperSlide
                                    key={index}
                                    className="h-auto swiper-slide"
                                    role="group"
                                    aria-roledescription="slide"
                                    aria-label={`Testimonial ${index + 1}: ${testimonial.name}`}
                                >
                                    <div className="flex flex-col justify-between h-full gap-20 py-6 pl-5 pr-8 border-r border-black lg:gap-44">
                                        <div className="flex items-start justify-between gap-12 ">
                                            <p className="m-body-l md:d-body-l">
                                                {testimonial.quote}
                                            </p>
                                            <img
                                                width={24}
                                                height={24}
                                                src="/icon_quote.svg"
                                                alt="Quote Icon"
                                            />
                                        </div>

                                        <div>
                                            <p className="m-body-l">{testimonial.name}</p>
                                            <p className="mt-1 m-body-m md:d-body-m text-black/70">
                                                {testimonial.customerProject}
                                            </p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>

                {slider.link && (
                    <div className="flex mx-5 mt-8 md:mt-14">
                        <LinkElement className="btn btn-inverted" size="small" link={slider.link} />
                    </div>
                )}
            </div>
        </section>
    );
}
